import React from 'react'

const PopPage = ({children,onClick}) => {
  return (
    <div onClick={onClick} className='pop-page'>
       {children}
    </div>
  )
}

export default PopPage